import { useState } from "react";
import type { ReactNode } from "react";
import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/base/SectionHeading";

interface MovieSectionProps {
  eyebrow?: string;
  title: string;
  description?: string;
  movies: Movie[];
  action?: ReactNode;
  initialCount?: number;
  step?: number;
  paginate?: boolean;
}

export default function MovieSection({
  eyebrow,
  title,
  description,
  movies,
  action,
  initialCount = 10,
  step = 10,
  paginate = false,
}: MovieSectionProps) {
  const [visible, setVisible] = useState(initialCount);
  const list = paginate ? movies.slice(0, visible) : movies;
  const hasMore = paginate && visible < movies.length;

  return (
    <section className="mx-auto max-w-page px-4 md:px-8">
      <SectionHeading eyebrow={eyebrow} title={title} description={description} action={action} />
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
        {list.map((movie, index) => (
          <MovieCard key={movie.id} movie={movie} index={index} />
        ))}
      </div>
      {hasMore && (
        <div className="mt-8 flex justify-center">
          <button
            type="button"
            onClick={() => setVisible((prev) => prev + step)}
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-background-200/80 border border-background-300/70 text-foreground-950 text-sm font-medium hover:border-primary-500/60 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-add-line text-lg"></i>
            加载更多
          </button>
        </div>
      )}
    </section>
  );
}